module.exports = __webpack_public_path__ + "static/img/pic_shipin@2x.3603c8b0.png";